import { makeStyles } from '@material-ui/core/styles'

export const wikiContentStyle = makeStyles(theme => ({
  image: {
    width: '100%',
    cursor: 'pointer'
  },
  root: {
    width: '100%',
    paddingTop: theme.spacing(2)
  },
  subtitle: {
    fontSize: '0.7rem'
  },
  text: {
    fontSize: '0.9rem'
  },
  video: {
    width: '100%'
  }
}))
